export const ACTION_SET_SYNC_STORE = 'spms/global/SET_SYNC_STORE';

export const SYNC_USER = 'spms/global/SYNC_USER';
export const SYNC_CONFIG = 'spms/global/SYNC_CONFIG';

export const MIN_FILENAME_LENGTH = 3;
export const MAX_FILENAME_LENGTH = 100;
export const MAX_FILE_SIZE = 100 * 1024 * 1024;

export const MAX_PHOTO_FILE_SIZE_MB = 1;
export const MAX_COMPRESSED_PHOTO_FILE_SIZE_MB = MAX_PHOTO_FILE_SIZE_MB * 0.25;
export const PHOTO_FILE_EXTENSIONS = ['.jpg', '.png'];

export const SPECIALISATION_TO_DETAILS = {
  ic: { label: 'Intelligent Computing' },
  ci: { label: 'Computing Infrastructure' },
  se: { label: 'Software Engineering' },
};

export const API_BASE_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://sptav2.usm.my/api/v1'
    : 'http://localhost:8000/api/v1';
export const DOWNLOAD_BASE_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://sptav2.usm.my/download'
    : 'http://localhost:8000/download';
export const MAX_RECONNECTION_TRIES = 5;
export const RECONNECTION_INTERVAL = 2000; // seconds

export const PAGINATION_PAGE_SIZE = 10;

export const PROJECT_REQUIREMENTS = {
  language: {
    label: 'Language',
    options: ['English', 'Malay', 'Chinese', 'Tamil'],
  },
  application: {
    label: 'Application',
    options: ['Mobile', 'Web', 'Desktop'],
  },
  operatingSystem: {
    label: 'Operating System',
    options: ['Android', 'iOS', 'Window', 'Mac', 'Linux'],
  },
  programmingLanguage: {
    label: 'Programming Language',
    options: ['Javascript', 'Python', 'Java', 'Swift', 'PHP', 'C#', 'C', 'C++'],
  },
  technology: {
    label: 'Technology',
    options: [
      'Artificial Intelligence',
      'Augmented Reality',
      'Big Data',
      'Computer Vision',
      'Machine Learning',
      'Internet of Things',
      'Virtual Reality',
    ],
  },
};

export const SKILL_COLOR_NAMES = [
  'materialpurple700',
  'materialindigo700',
  'materiallime700',
  'materialteal700',
  'materialpink700',
];

export const CONFIG_STATE_TYPE = {
  NEW: 1,
  COORD_READY: 2,
  LECT_READY: 3,
  TITLE_READY: 4,
  BID_READY: 5,
  BID: 6,
  EXAMINER_READY: 7,
  EVALUATION_READY: 8,
  EVALUATED: 9,
  COMPLETE: 10,
};

// CONFIG_FIELDS[role][field] = {
//   editableSince, requiredSince, uneditableSince,
//   configGetter (optional, config => value)
// }
export const CONFIG_FIELDS = {
  admin: {
    academicSession: {
      editableSince: CONFIG_STATE_TYPE.NEW,
      requiredSince: CONFIG_STATE_TYPE.NEW,
      uneditableSince: CONFIG_STATE_TYPE.COORD_READY,
    },
  },
  coordinator: {
    isSupervisorVisible: {
      editableSince: CONFIG_STATE_TYPE.COORD_READY,
      requiredSince: CONFIG_STATE_TYPE.COORD_READY,
      uneditableSince: CONFIG_STATE_TYPE.COMPLETE,
    },
    isProjectVisibleToOtherLecturers: {
      editableSince: CONFIG_STATE_TYPE.COORD_READY,
      requiredSince: CONFIG_STATE_TYPE.COORD_READY,
      uneditableSince: CONFIG_STATE_TYPE.COMPLETE,
    },
    supervisorTitleQuota: {
      editableSince: CONFIG_STATE_TYPE.COORD_READY,
      requiredSince: CONFIG_STATE_TYPE.COORD_READY,
      uneditableSince: CONFIG_STATE_TYPE.LECT_READY,
    },
    lecturerQuota: {
      editableSince: CONFIG_STATE_TYPE.COORD_READY,
      requiredSince: CONFIG_STATE_TYPE.COORD_READY,
      uneditableSince: CONFIG_STATE_TYPE.LECT_READY,
    },
    bidQuota: {
      editableSince: CONFIG_STATE_TYPE.COORD_READY,
      requiredSince: CONFIG_STATE_TYPE.COORD_READY,
      uneditableSince: CONFIG_STATE_TYPE.LECT_READY,
    },
    bidRoundCount: {
      editableSince: CONFIG_STATE_TYPE.COORD_READY,
      requiredSince: CONFIG_STATE_TYPE.COORD_READY,
      uneditableSince: CONFIG_STATE_TYPE.LECT_READY,
      configGetter: config => (config.bidRounds ? config.bidRounds.length : 0),
    },
    projectStages: {
      editableSince: CONFIG_STATE_TYPE.COORD_READY,
      requiredSince: CONFIG_STATE_TYPE.COORD_READY,
      uneditableSince: CONFIG_STATE_TYPE.LECT_READY,
    },
    titleSubmissionRoundDates: {
      editableSince: CONFIG_STATE_TYPE.COORD_READY,
      requiredSince: CONFIG_STATE_TYPE.COORD_READY,
      uneditableSince: CONFIG_STATE_TYPE.TITLE_READY,
    },
    // Additional
    projectCategories: {
      editableSince: CONFIG_STATE_TYPE.COORD_READY,
      requiredSince: CONFIG_STATE_TYPE.COORD_READY,
      uneditableSince: CONFIG_STATE_TYPE.LECT_READY,
    },
  },
};

export const FIELD_CONSTRAINTS = {
  // Config
  bidRoundCount: { min: 1, max: 5 },
  supervisorTitleQuota: { min: 1, max: 15 },
  lecturerQuota: { min: 1, max: 15 },
  bidQuota: { min: 1, max: 5 },
  // Project
  version: { min: 1, max: 99 },
  difficulty: { min: 1, max: 5 },
  requirementValueLen: {
    min: 1,
    max: Math.max(
      40,
      ...Object.keys(PROJECT_REQUIREMENTS).map(fieldName =>
        Math.max(
          ...PROJECT_REQUIREMENTS[fieldName].options.map(
            options => options.length,
          ),
        ),
      ),
    ),
  },
  // Student
  introductionLen: { min: 1, max: 300 },
};

export const STUDENT_FIELDS = {
  honorific: {
    options: ['Mr.', 'Mrs.', 'Ms.'],
  },
  major: {
    options: [
      'Software Engineering',
      'Intelligent System',
      'Networking',
      'Multimedia',
      'Cyber Security',
      'Information System Engineering',
    ],
  },
  muet: {
    options: ['BAND 1', 'BAND 2', 'BAND 3', 'BAND 4', 'BAND 5', 'BAND 6'],
  },
};

export const GRADE_GROUPS = [
  {
    title: 'Superior Command',
    grades: ['A', 'A-'],
  },
  {
    title: 'Good Control',
    grades: ['B+', 'B', 'B-'],
  },
  {
    title: 'Fair/Some Control',
    grades: ['C+', 'C'],
  },
  {
    title: 'Minimal or No Control',
    grades: ['C-', 'D+', 'D', 'D-', 'F'],
  },
];

export const LECTURER_HONORIFIC_TO_POSITION = {
  'Mr.': 'Senior Lecturer',
  'Ms.': 'Senior Lecturer',
  'Mrs.': 'Senior Lecturer',
  'Dr.': 'Senior Lecturer',
  'Assoc. Prof.': 'Associate Professor',
  'Prof.': 'Professor',
};

export const GRADE_TO_POINTS = {
  A: 4.0,
  'A-': 3.67,
  'B+': 3.33,
  B: 3.0,
  'B-': 2.67,
  'C+': 2.33,
  C: 2.0,
  'C-': 1.67,
  'D+': 1.33,
  D: 1.0,
  'D-': 0.67,
  F: 0.0,
};

export const GRADING_STATE_LABEL = {
  ungraded: 'N/A',
  nongradable: '-',
};

export const SETTING_RADIO_OPTIONS = {
  isSupervisorVisible: {
    true: 'Allow',
    false: "Don't Allow",
  },
  isCurr: {
    true: 'Yes',
    false: 'No',
  },
};
